import React, { useMemo } from 'react';
import { mapCompetenceSummaryData } from '../utils';
import RatingOption from '../../core/RatingScale/RatingOption';
import { useTranslations } from '../../context/TranslationContext';
import "./index.less";

const CompetenceSummary = ({ summary: data }) => {
    const { t } = useTranslations();
    const summaryData = useMemo(() => mapCompetenceSummaryData(data), [data]);
    const records = Object.entries(summaryData);

    return (
        <div className='competence-summary-wrap'>
            <div className='content-wrap'>
                {records.length === 0 && (
                    <h6 className='no-data-placeholder'>{t('No evaluations')}</h6>
                )}
                {records.map(([attribute, data], index) => (
                    <div className='inner-wrap' key={index}>
                        <div className='title-wrap'>{data.attribute_title || attribute}</div>
                        <div className='icons-row'>
                            {data?.items?.map(({ icon, color, label }, i) => {
                                return (
                                    <RatingOption
                                        key={i}
                                        label={label}
                                        color={color}
                                        readOnly
                                        icon={icon}
                                    />
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CompetenceSummary;
